var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1H15C17.2091 1 19 2.79086 19 5V11C19 11.4595 18.9225 11.901 18.7799 12.312C18.7587 12.2987 18.7371 12.2856 18.7151 12.2727L9.1037 6.66221C8.41504 6.26021 7.55338 6.30571 6.91088 6.77799L1.00181 11.1216C1.00061 11.0812 1 11.0407 1 11V5C1 2.79086 2.79086 1 5 1ZM0.0652797 11.81C0.0223296 11.5464 0 11.2758 0 11V5C0 2.23858 2.23858 0 5 0H14.9999C17.7613 0 19.9999 2.23858 19.9999 5V11C19.9999 13.7614 17.7613 16 14.9999 16H5H4.99992C2.51431 16 0.452322 14.1863 0.065211 11.8101L0.0652797 11.81ZM4.68841 5.33333C5.26384 5.33333 5.73033 4.73638 5.73033 4C5.73033 3.26362 5.26384 2.66667 4.68841 2.66667C4.11297 2.66667 3.64648 3.26362 3.64648 4C3.64648 4.73638 4.11297 5.33333 4.68841 5.33333Z",
    fill: "#7D94AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.d47c16d1d370bb10f1422c2a0d79989c.svg";
export { ForwardRef as ReactComponent };